/**
 * The application's definition of the default color black.
 */
const BLACK = '#111111';
const MEETHOURBLUE = '#4B6790';
const MEETHOURDARKBLUE = '#4B6790';
const CONFERENCE_BACKGROUND = '#4B6790';

const PRIMARY = '#4B6790';
const SECONDARY = '#1ACC8D';
const PAGE_BACKGROUND = '#eff6ff';

const ACCENT1 = '#ffffff';
const ACCENT2 = '#dc3c4e';
const ACCENT3 = '#303030';
const ACCENT4 = '#374151';

const TILE_BACKGROUND = 'multiple';

const defaultBrandingColorPalette = {
    accent1: '#ffffff',
    accent2: '#dc3c4e',
    background: '#eff6ff',
    primary: '#4b6790',
    secondary: '#1acc8d',
    tileBackground: 'multiple',
    accent3: '#303030',
    accent4: '#374151',
    accent5: '#000000'
};

/**
 * Dynamic branding color palette based on the interface configuration.
 */
export function getBrandingColorPalette(interfaceConfig) {

    return {
        primary: interfaceConfig?.applyMeetingSettings === true ? interfaceConfig?.BRAND_COLORS?.primary || defaultBrandingColorPalette.primary : PRIMARY,
        secondary: interfaceConfig?.applyMeetingSettings === true ? interfaceConfig?.BRAND_COLORS?.secondary || defaultBrandingColorPalette.secondary : SECONDARY,
        background: interfaceConfig?.applyMeetingSettings === true ? interfaceConfig?.BRAND_COLORS?.background || defaultBrandingColorPalette.background : PAGE_BACKGROUND,
        tileBackground: interfaceConfig?.applyMeetingSettings === true ? interfaceConfig?.BRAND_COLORS?.tileBackground || defaultBrandingColorPalette.tileBackground : TILE_BACKGROUND,
        accent1: interfaceConfig?.applyMeetingSettings === true ? interfaceConfig?.BRAND_COLORS?.accent1 || defaultBrandingColorPalette.accent1 : ACCENT1,
        accent2: interfaceConfig?.applyMeetingSettings === true ? interfaceConfig?.BRAND_COLORS?.accent2 || defaultBrandingColorPalette.accent2 : ACCENT2,
        accent3: interfaceConfig?.applyMeetingSettings === true ? interfaceConfig?.BRAND_COLORS?.accent3 || defaultBrandingColorPalette.accent3 : ACCENT3,
        accent4: interfaceConfig?.applyMeetingSettings === true ? interfaceConfig?.BRAND_COLORS?.accent4 || defaultBrandingColorPalette.accent4 : ACCENT4
    };
}

/**
 * The application's color palette.
 */
export const ColorPalette = {
    /**
     * The application's background color.
     */
    appBackground: CONFERENCE_BACKGROUND,

    /**
     * The application's definition of the default color black. Generally,
     * expected to be kept in sync with the application's background color for
     * the sake of consistency.
     */
    black: BLACK,
    blackBlue: 'rgb(0, 3, 6)',
    blue: MEETHOURBLUE,
    darkblue: MEETHOURDARKBLUE,
    blueHighlight: '#3A54B1',
    pink: '#DD7C82',
    pinkHighlight: '#FD9FA6',
    buttonUnderlay: '#495258',
    darkGrey: '#555555',
    darkBackground: 'rgb(19,21,25)',
    toolbarBackground: 'rgba(49,71,91,.88)',
    green: '#1acc8d',
    lightGrey: '#AAAAAA',
    overflowMenuItemUnderlay: '#EEEEEE',
    red: '#D00000',
    transparent: 'rgba(0, 0, 0, 0)',
    warning: 'rgb(215, 121, 118)',
    white: '#FFFFFF',
    accent3: '#303030',
    accent4: '#374151',

    /**
     * These are colors from the atlaskit to be used on mobile, when needed.
     *
     * FIXME: Maybe a better solution would be good, or a native packaging of
     * the respective atlaskit components.
     */
    G400: '#00875A', // Slime
    N500: '#42526E', // McFanning
    R400: '#DE350B', // Red dirt
    Y200: '#FFC400' // Pub mix
};
